import { Chart, Filler } from "chart.js";
import annotationPlugin from "chartjs-plugin-annotation";
import { useEffect, useMemo, useState } from "react";
import * as S from "./style.styled";

import { appSelect } from "@entities/app";
import { authInfoSelect } from "@entities/auth";
import { BarChart } from "@pages/dashboard/plugins/components/charts";
import { IBarCharCard } from "@types";
import { API_DATE_FORMAT } from "@utils/const";
import { transformCardsData } from "@utils/functions/transformCardsData";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import CardSelector from "../components/CardSelector";

Chart.register(Filler, annotationPlugin);

const selectOptionsQ = [
  { key: "quontity", value: "quontity", label: "Количество визитов" },
  { key: "amount", value: "amount", label: "Суммы бонусов" },
];

const initialValue: IBarCharCard[] = new Array(2).fill({
  labels: [],
  datasets: [
    {
      label: "",
      data: [],
      borderRadius: 10,
      borderSkipped: false,
      barThickness: 14,
    },
  ],
});

export function Plag3() {
  const { shop } = useSelector(authInfoSelect);
  const { from, to } = useSelector(appSelect).dateRange;
  const [chartData, setChartData] = useState<IBarCharCard[]>(initialValue);
  const [selectQ, setSelectQ] = useState<number>(0);

  const urlForCardsPlagin = useMemo(() => {
    if (!shop?.id) return null;

    const startDate = from
      ? dayjs(from, API_DATE_FORMAT).format(API_DATE_FORMAT)
      : "2024-01-01";
    const endDate = to
      ? dayjs(to, API_DATE_FORMAT).format(API_DATE_FORMAT)
      : "2024-11-01";

    return `${process.env.REACT_APP_API_URL}/shops/${shop.id}/loyalty/card-templates/count-usage?from=${startDate}&to=${endDate}`;
  }, [from, to, shop]);

  useEffect(() => {
    if (!urlForCardsPlagin) return;

    fetch(urlForCardsPlagin, {
      headers: {
        accept: "application/json",
        Authorization: `${localStorage.getItem("accessToken")}`,
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setChartData(initialValue);
        if (data && data.length > 0) {
          setChartData(transformCardsData(data));
        }
      })
      .catch((err) => console.error("Error fetching card data:", err));
  }, [urlForCardsPlagin]);

  return (
    <S.Palg3Wrap>
      <S.HeaderWrapper>
        <S.Header>Карты и лояльность</S.Header>
        <S.WrapSelect>
          <CardSelector
            select={selectQ}
            setSelect={setSelectQ}
            selectOptions={selectOptionsQ}
          />
        </S.WrapSelect>
      </S.HeaderWrapper>
      <BarChart
        labels={chartData[selectQ].labels}
        datasets={chartData[selectQ].datasets}
      />
      <style>
        {`
          .chartjs-render-monitor {
            position: relative;
          }
          .chartjs-render-monitor .tick {
            background-color: blue;
            color: white;
            padding: 2px 4px;
            border-radius: 3px;
          }
        `}
      </style>
    </S.Palg3Wrap>
  );
}
